module.exports = __webpack_public_path__ + "fonts/Inter-800-cyrillic-ext71.251d36f.woff2";